import { Component } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { SharedModule } from '../../../shared/shared.module'

@Component({
    selector: 'app-public-header',
    templateUrl: './header.component.html',
    imports: [SharedModule],
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  appName: string

  constructor() {
    this.appName = environment.appTitle ? environment.appTitle : 'ADDboard'
  }
}
